import { HandleListener } from "./HandleListener"

class HandleTask { 

    private _activity: Array<HandleListener>
    private _working: boolean;

    constructor(){
        this._activity = []
        this._working = false
    }

    append = (doing: () => void, name: string = 'somename', priority: number = 0) => {
        const find = this._activity.find(oi=>oi.name === name)
        if(find){
            find.doing = doing
        } else {
        this._activity.push(new HandleListener({ doing, name, priority }));
        }
    };

    do = async () => {
        if(this._working){
            console.warn('Allready warking')
            return
        }
        this._working = true
        this._activity.forEach(async (listener)=>{
            await listener.do()
        })
        this.clear()
        this._working = false
    }

    clear = () => {
        this._activity = []
    }
}

export { HandleTask }

